import { FC, SVGProps } from 'react';

const UserProfileIcon: FC<SVGProps<SVGSVGElement> & { size?: number }> = ({ color = '#fff', size = 20, ...props }) => {
  return (
    <svg width={size} height={size} viewBox="0 0 20 20" xmlns="http://www.w3.org/2000/svg" {...props} fill="none">
      <path
        d="M17.5 10C17.5 5.85757 14.1424 2.5 10 2.5C5.85757 2.5 2.5 5.85757 2.5 10C2.5 14.1416 5.85757 17.5 10 17.5C14.1424 17.5 17.5 14.1416 17.5 10Z"
        stroke={color}
        stroke-width="1.5"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
      <path
        d="M5.70947 16.1457C5.87975 14.824 7.05542 13.3564 9.97435 13.3564C12.9257 13.3564 14.0933 14.8322 14.2554 16.17"
        stroke={color}
        stroke-width="1.5"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
      <path
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M12.7233 8.60558C12.7233 10.1226 11.494 11.3518 9.97701 11.3518C8.46001 11.3518 7.22998 10.1226 7.22998 8.60558C7.22998 7.08857 8.46001 5.85938 9.97701 5.85938C11.494 5.85938 12.7233 7.08857 12.7233 8.60558Z"
        stroke={color}
        stroke-width="1.5"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
    </svg>
  );
};

export default UserProfileIcon;
